import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../../shared/directives/focus-me.directive';

export const RESPONSE_CONFIRM = 0;
const RESPONSE_CANCEL = 1;

@Component({
	selector: 'copo-claim-utils-dialog-unrecognized-batch',
	templateUrl: './dialog-unrecognized-batch.component.html',
	styleUrl: './dialog-unrecognized-batch.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, NgIf, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class DialogUnrecognizedBatchComponent {
	unrecognizedBatch: string | undefined;

	constructor(

		private readonly dialogRef: MatDialogRef<DialogUnrecognizedBatchComponent, number>
	) {}

	evtCancel() {
		this.dialogRef.close(RESPONSE_CANCEL);
	}

	evtConfirm() {
		this.dialogRef.close(RESPONSE_CONFIRM);
	}
}
